/**
 *  @fileOverview Search module
 *
 *  @author       Aaron Chapman / Chris Hill
 *
 */

function SearchModule (axios, autocomplete, AutocompleteModule, disableBodyScroll, enableBodyScroll, Utilities) {
  /**
   * @description Initialises page search overlay.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Define search button
     */
    const searchButton = document.querySelector('.siteHeader__searchButton')

    /**
     * Check if search button is on the page, if so build search overlay
     */
    if (typeof searchButton !== 'undefined' && searchButton !== null) {
      createSearch()

      /**
       * Setup autocomplete
       */

      let autocomp = new AutocompleteModule(axios, autocomplete, Utilities)
      autocomp.init({
        input: 'searchQ',
        container: '#search__container',
        name: 'query'
      })

      /**
       * Define elements
       */
      const body = document.querySelector('body')
      const searchOverlay = document.querySelector('.searchOverlay')
      const searchInput = document.querySelector('#searchQ')
      const searchClose = document.querySelector('.search__close')
      const searchForm = document.querySelector('.search__form')
      // const env = document.location.href.includes('wwwqa.') ? 'https://wwwqa.' : 'https://www.'

      /**
       * On click of the search button show overlay
       */
      searchButton.addEventListener('click', function (e) {
        openCloseSearch(searchOverlay, body, searchInput)
      })

      /**
       * On click of the close button hide overlay
       */
      searchClose.addEventListener('click', function (e) {
        openCloseSearch(searchOverlay, body, searchInput)
      })

      body.addEventListener('keydown', function (e) {
        /**
         * Call open close only if exc key pressed and overlay already open
         */
        if (e.which === 27 && searchOverlay.classList.contains('searchOverlay--open')) {
          openCloseSearch(searchOverlay, body, searchInput)
        }
      })

      /**
       * On submit of the form send query to funnelback
       */
      searchForm.addEventListener('submit', function (e) {
        e.preventDefault()

        const searchURL = `https://www.ecu.edu.au/degrees/courses?query=${encodeURIComponent(searchInput.value)}&collection=ecu-web&profile=ecu2020`
        location.assign(searchURL)
      })
    }

    /**
     * @description Function creates search overlay and inserts into DOM.
     *
     * @param {Object} searchOverlay - Overlay element.
     * @param {Object} body - Body element.
     * @param {Object} searchInput - Overlay element.
     *
     * @example
     * //
     * // returns NULL
     */
    function openCloseSearch (searchOverlay, body, searchInput) {
      searchOverlay.classList.toggle('searchOverlay--open')
      body.classList.toggle('menu-lock')

      if (searchOverlay.classList.contains('searchOverlay--open')) {
        disableBodyScroll(searchOverlay)
        searchInput.focus()
      } else {
        enableBodyScroll(searchOverlay)
      }
    }

    /**
     * @description Function creates search overlay and inserts into DOM.
     *
     * @example
     * //
     * // returns NULL
     */
    function createSearch () {
      /**
       * Define base overlay HTML
       */
      var html = `<button class="search__close" aria-label="close search">
                      <span class="search__closeText">Close</span>
                      <i class="search__closeIcon fas fa-times"></i>
                  </button>
                  <form role="search" id="search__container" class="search__form" >
                    <label for="searchQ" class="search__label">Type anything and hit "enter"</label>
                    <button type="submit" class="searchSubmit" value="Do search" aria-label="Do search"><i class="fas fa-search"></i></button>
                  </form>
                  <div class="search__results"></div>
                  <aside class="search__otherOptions">
                      <!--<div class="search__chatLive">
                      <span>Can't find what you're looking for?</span>
                      <a href="" class="search__otherOptionLink" title="Chat live">
                        <i class="fas fa-comment fa-flip-horizontal"></i>Chat live
                      </a>
                    </div>-->
                    <div class="search__askUs">
                      <span>Got a question?</span>
                      <a href="https://askus.ecu.edu.au/" class="search__otherOptionLink" title="Ask us">
                        <i class="iconOnLeft fas fa-comment-dots fa-flip-horizontal fa-lg"></i>Ask us
                      </a>
                    </div>
                  </aside>`

      const footer = document.querySelector('footer')

      /**
       * Create element to hold overlay
       */
      let overlay = document.createElement('div')
      overlay.classList.add('searchOverlay')
      overlay.innerHTML = html

      /**
       * Insert the overlay before the footer
       */
      if (typeof footer !== 'undefined' && footer !== null) {
        footer.parentNode.insertBefore(overlay, footer)
      } else {
        document.querySelector('body').appendChild(overlay)
      }
    }
  }
}

module.exports = SearchModule
